import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ReleaseNoteDto } from '@app/generated/model';
import { ReleaseNoteService } from '@app/core/services/release-note.service';

@Component({
  selector: 'app-add-release-note',
  templateUrl: './add-release-note.component.html',
  styleUrls: ['./add-release-note.component.scss'],
  standalone: false,
})
export class AddReleaseNoteComponent {
  form: UntypedFormGroup;
  types = [
    { value: 'feature', label: 'Feature' },
    { value: 'bugfix', label: 'Bugfix' },
  ];

  constructor(
    formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddReleaseNoteComponent>,
    private releaseNoteService: ReleaseNoteService,
  ) {
    this.form = formBuilder.group({
      version: ['', Validators.required],
      date: ['', [Validators.required, Validators.pattern(/^\d{4}-\d{2}-\d{2}$/)]],
      type: ['', Validators.required],
      title: ['', Validators.required],
      description: ['', Validators.required],
    });
  }

  async onAdd() {
    if (!this.form.valid) {
      return;
    }
    const releaseNote = this.form.getRawValue() as ReleaseNoteDto;
    this.releaseNoteService.addReleaseNote(releaseNote).subscribe();
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
